export default __webpack_public_path__ + "static/media/landing-mike-icon.a423801d.png";